// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import './assets/icon/iconfont.css'
import './assets/icon/iconfont'
import './assets/icon/iconfont.json'
import './assets/icon/iconfont.ttf'
import './assets/icon/demo.css'
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)
const historyURL = require('connect-history-api-fallback')
const dataSources = require('../static/dataSources/sources.json')
Vue.use('/', historyURL());
// 
Vue.use(VideoPlayer)
Vue.use(Element)
Vue.prototype.$json = dataSources
Vue.config.productionTip = false
    /* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js